module.exports = __webpack_public_path__ + "img/direktabrechnung.efb560ad.svg";